import React from 'react';
import { Settings, Music2, Users, MessageSquare, Mic, Share2, BookMarked, Home, LogOut, ArrowLeft, Edit, User, UserPlus } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { NotificationBadge } from './NotificationBadge';
import { cn } from '../../lib/utils';

export function ProfileNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const isContentView = location.pathname.split('/').length > 3;
  
  // Get current section from URL
  const currentSection = location.pathname.split('/')[3] || '';
  
  const handleLogout = async () => {
    try {
      await logout();
      navigate('/auth');
    } catch (error) {
      console.error('Fehler beim Ausloggen:', error);
    }
  };
  
  return (
    <div className="w-full md:w-60 bg-background-secondary h-screen flex flex-col">
      <div className="p-4 border-b border-divider flex items-center gap-3">
        {isContentView && (
          <button 
            onClick={() => navigate(-1)}
            className="md:hidden p-2 hover:bg-background-tertiary rounded-full"
          >
            <ArrowLeft size={20} />
          </button>
        )}
        <h2 className="text-text-primary font-bold">Profil</h2>
      </div>
      
      <div className="flex-1 p-4">
        <nav className="space-y-1">
          <Link 
            to="/app/profile/feed" 
            className={cn(
              "flex items-center w-full px-3 py-2 rounded-md transition-colors",
              currentSection === 'feed'
                ? "bg-accent-primary/10 text-accent-primary"
                : "text-text-secondary hover:text-text-primary hover:bg-background-tertiary"
            )}
          >
            <Home size={18} className="mr-3" />
            Feed
          </Link>
          <Link 
            to="/app/profile/edit" 
            className={cn(
              "flex items-center w-full px-3 py-2 rounded-md transition-colors",
              currentSection === 'edit'
                ? "bg-accent-primary/10 text-accent-primary"
                : "text-text-secondary hover:text-text-primary hover:bg-background-tertiary"
            )}
          >
            <User size={18} className="mr-3" />
            Mein Profil
          </Link>
          <Link 
            to="/app/profile/messages" 
            className={cn(
              "flex items-center w-full px-3 py-2 rounded-md transition-colors",
              currentSection === 'messages'
                ? "bg-accent-primary/10 text-accent-primary"
                : "text-text-secondary hover:text-text-primary hover:bg-background-tertiary"
            )}
          >
            <MessageSquare size={18} className="mr-3" />
            Nachrichten
            <NotificationBadge type="message" />
          </Link>
          <Link 
            to="/app/profile/follow-requests" 
            className={cn(
              "flex items-center w-full px-3 py-2 rounded-md transition-colors",
              currentSection === 'follow-requests'
                ? "bg-accent-primary/10 text-accent-primary"
                : "text-text-secondary hover:text-text-primary hover:bg-background-tertiary"
            )}
          >
            <Users size={18} className="mr-3" />
            Freunde
            <NotificationBadge type="follow_request" />
          </Link>
        </nav>
      </div>

      <div className="p-4 border-t border-divider space-y-2">
        <Link 
          to="/app/profile/settings" 
          className={cn(
            "flex items-center w-full px-3 py-2 rounded-md transition-colors",
            currentSection === 'settings'
              ? "bg-accent-primary/10 text-accent-primary"
              : "text-text-secondary hover:text-text-primary hover:bg-background-tertiary"
          )}
        >
          <Settings size={18} className="mr-3" />
          Einstellungen
        </Link>
        <button
          onClick={handleLogout}
          className="flex items-center w-full px-3 py-2 text-text-secondary hover:text-text-primary hover:bg-background-tertiary rounded-md"
        >
          <LogOut size={18} className="mr-3" />
          Ausloggen
        </button>
      </div>
    </div>
  );
}